import React, {FC, Fragment} from 'react';

import useBreakpointMD from 'hooks/useBreakpointMD';
import AdRepeated from 'components/Common/AdRepeated';
// import useTimelineData from 'hooks/useTimelineData';
import breakpoints from 'utils/breakpoints';
import {Sport, TeamInfo, TimelineUpdate, TimelineUpdateType} from '../../../utils/types';

import {
  TimelineUpdateEditor,
  TimelineUpdateGoal,
  TimelineUpdateSimple,
  TimelineUpdateStatus,
} from '../TimelineUpdates';

import './styles.scss';


interface Props {
  updates: TimelineUpdate[];
  sport: Sport;
  teams: {home: TeamInfo; away: TeamInfo};
  commentaryEnabled: boolean;
}

interface PinnedProps {
  updates: TimelineUpdate[];
  commentaryEnabled: boolean;
}

const PinnedComment: FC<PinnedProps> = ({updates, commentaryEnabled}: PinnedProps) => {

  const pinnedUpdate = updates.find(update => update.isPinned)
  


  return (
    <>
      {pinnedUpdate && commentaryEnabled && (
        <TimelineUpdateEditor key={pinnedUpdate.id} update={pinnedUpdate} />
      )}
    </>    
  )
}

const Timeline: FC<Props> = ({updates, sport, teams, commentaryEnabled}: Props) => {
  const isBreakpointMD = useBreakpointMD();

  return (
    <section className="Timeline">
      <div className="Timeline__updates">
      <PinnedComment updates={updates} commentaryEnabled={commentaryEnabled}/>
        {updates.map((update, i) => {
          let event;
          switch (update.type) {
            case TimelineUpdateType.OPEN_TEXT:
            case TimelineUpdateType.EDITOR_INFO:
            case TimelineUpdateType.EDITOR_HIGHLIGHT:
            case TimelineUpdateType.EXPERT_COMMENT:
            case TimelineUpdateType.PHOTO_HIGHLIGHT:
            case TimelineUpdateType.VIDEO_HIGHLIGHT:
            case TimelineUpdateType.SOCIAL:
            case TimelineUpdateType.SPONSORED:
            case TimelineUpdateType.OPTA_DATA:
            case TimelineUpdateType.GOOD_OPPORTUNITY:
            case TimelineUpdateType.GOOD_MOMENT:
            case TimelineUpdateType.HISTORIC_FACT:
            case TimelineUpdateType.VIOLENT_INCIDENT:
            case TimelineUpdateType.VAR:
            case TimelineUpdateType.BUZZER_BEATER:
            case TimelineUpdateType.FIVE_OMADIKO_FAUL:
            case TimelineUpdateType.ON_FIRE:
            case TimelineUpdateType.REFEREE:
            case TimelineUpdateType.TECHNICAL_PENALTY:
            case TimelineUpdateType.DISQUALIFICATION:
                event = (!update.isPinned && commentaryEnabled) && <TimelineUpdateEditor update={update} />
              
              break;
            case TimelineUpdateType.SCORE_CHANGE:
            case TimelineUpdateType.AUTOGOAL:
            case TimelineUpdateType.POINT:
              if ([Sport.BASKETBALL, Sport.HANDBALL, Sport.VOLLEYBALL, Sport.TENNIS].includes(sport))
                event = <TimelineUpdateSimple update={update} sport={sport} teams={teams} />;
              else event = <TimelineUpdateGoal update={update} teams={teams} />;
              break;
            case TimelineUpdateType.MATCH_STARTED:
            case TimelineUpdateType.MATCH_ENDED:
            case TimelineUpdateType.BREAK_START:
            case TimelineUpdateType.PERIOD_START:
            case TimelineUpdateType.PERIOD_SCORE:
            case TimelineUpdateType.PERIOD_ENDED:
            case TimelineUpdateType.PENALTY_SHOOTOUT:
            case TimelineUpdateType.INJURY_TIME_SHOWN:
              if ((sport === Sport.TENNIS || sport === Sport.VOLLEYBALL) && update.type === TimelineUpdateType.PERIOD_SCORE)
                event = <TimelineUpdateSimple update={update} sport={sport} teams={teams} />;
              else event = <TimelineUpdateStatus update={update} sport={sport} teams={teams} />;
              break;
            default:
              event = <TimelineUpdateSimple update={update} teams={teams} />;
          }
          return (
            <Fragment key={`${update.id}-container`}>
              {event}
              {!isBreakpointMD && (
                <AdRepeated
                  adUnitRoot="sport24.gr/Matchcenter_ros_300x250"
                  adUnitLetters={['A', 'B', 'C', 'D']}
                  index={i}
                  step={15}
                  scope="timeline"
                  sizes={[
                    [300, 250],
                    [320, 100],
                  ]}
                  sizeMapping={[
                    {viewport: [breakpoints.md, 0], sizes: []},
                    {
                      viewport: [0, 0],
                      sizes: [
                        [300, 250],
                        [320, 100],
                      ],
                    },
                  ]}
                />
              )}
            </Fragment>
          );
        })}
      </div>
    </section>
  );
};

export default Timeline;
